module.exports = {"title":"Axis Tick Formatting","path":"axis-tick-formatting","published":false}